export enum PowerUnits {
    A,
    W
}